// Lichte identiteit (geen wachtwoord) — passend voor een privé familietool.
const KEY = "pv.user";

export const USERS = {
  matthijs: { id: "matthijs", name: "Matthijs", emoji: "👨", role: "editor" },
  anna:     { id: "anna",     name: "Anna",     emoji: "👩", role: "editor" },
  viewer:   { id: "viewer",   name: "Viewer",   emoji: "👁", role: "viewer" },
};

export function getUser() {
  // Een ?rol=viewer in de URL forceert altijd alleen-lezen (deel-link).
  try {
    const p = new URLSearchParams(window.location.search);
    if (p.get("rol") === "viewer") return "viewer";
  } catch {}
  try { return localStorage.getItem(KEY); } catch { return null; }
}
export function setUser(id) { try { localStorage.setItem(KEY, id); } catch {} }
export function canEditUser(id) { return id === "matthijs" || id === "anna"; }
